const focusableHeaderSelectors = "button, [href], input:not([disabled])";

const getFocusables = (menuEl) => {
  if (!menuEl) return;

  const focusables = Array.from(menuEl.querySelectorAll(`${focusableHeaderSelectors}`));
  return focusables.filter((node) => isVisible(node));
};

const isVisible = (el) => {
  const styles = window.getComputedStyle(el);
  if (styles.display === 'none' || styles.visibility === 'hidden') return false;

  return !!( el.offsetWidth || el.offsetHeight || el.getClientRects().length );
};

const indexOfFocusedItem = (list, focusedItem) => {
  let index = -1;
  for (let i = 0; i <  list.length; i++ ) {
    if (list[i].isEqualNode(focusedItem)) {
      index = i;
    }
  }

  return index;
};

const onTabKeyDownCallback = (e, focusableElements, callback) => {
  const focusedItem = document.activeElement;
  const focusedItemIndex = indexOfFocusedItem(focusableElements, focusedItem);

  if (e.shiftKey && e.key === 'Tab') {
    if (focusedItemIndex === -1 || focusedItemIndex === 0) {
      callback();
    }
  } else if (e.key === 'Tab') {
    if (focusedItemIndex === focusableElements.length - 1) {
      callback();
    }
  }
};

export {
  getFocusables,
  onTabKeyDownCallback,
};
